// Local translations
export const T = {
  en_GB: {
    assetClass: "Asset Class",
    allocation: "Allocation",
    unclassified: "Unclassified",
    snapshotTaken: (time: string) => `Snapshot taken ${time}`,
  },
  nb_NO: {
    assetClass: "Aktivaklasse",
    allocation: "Allokering",
    unclassified: "Uklassifisert",
    snapshotTaken: (time: string) => `Øyeblikksbilde tatt ${time}`,
  },
} as const;
